// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-425db76c] .ag-header-cell-text{text-align:right !important}[data-v-425db76c] .automated-payment-prediction{background:linear-gradient(90deg, rgba(146, 254, 157, 0.06) 0%, rgba(0, 201, 255, 0.06) 100%) !important}[data-v-425db76c] .automated-payment-notification{background:linear-gradient(90deg, rgba(255, 78, 80, 0.1) 0%, rgba(249, 212, 35, 0.1) 100%) !important}", ""]);
// Exports
module.exports = exports;
